import { useCallback } from 'react'

import { ComplexesListItem } from 'app/common/types/food/schools/complexes/sort'

import {
  PlainDraggableListProvider,
  PlainDraggableList,
  type OnDragEndResponder,
} from 'app/common/ui-components/plain-draggable-list'

import { KitItem } from './kitItem'
import styles from './SortKit.module.scss'

type Props = {
  kitList: Array<ComplexesListItem>
  disabled: boolean
  moveItem: (indexFrom: number, indexTo: number) => Promise<void>
}

export const SortKit = ({ kitList, disabled, moveItem }: Props) => {
  const handleDragEnd: OnDragEndResponder = useCallback(
    ({ destination, source }) => {
      if (!destination || disabled) return
      const { index: indexDestination } = destination
      const { index: indexSource } = source
      moveItem(indexSource, indexDestination)
    },
    [moveItem, disabled],
  )

  return (
    <div className={styles.root}>
      <div className={styles.headerTable}>
        <span>Наименования комплекта</span>
        <span>Позиция</span>
      </div>

      <PlainDraggableListProvider onDragEnd={handleDragEnd}>
        <PlainDraggableList droppableId="sortKist" injectDraggableStateSnapshot>
          {kitList.map((props, i) => {
            const { id } = props

            return <KitItem key={id} {...props} />
          })}
        </PlainDraggableList>
      </PlainDraggableListProvider>
    </div>
  )
}
